<ez-section>
  <ez-block>
    <div class="phms-manual-intake-submission">
      <div class="page-header">
        <div>
          <h2>{{ pageTitle }}</h2>
          <p class="page-subtitle">{{ pageSubtitle() }}</p>
        </div>
      </div>

      <p class="loading-text" *ngIf="!canSubmit()" role="status" aria-live="polite">
        You do not have permission to submit intake submissions. Frontend gating is a UX hint - server authorization is authoritative.
      </p>

      <ng-container *ngIf="canSubmit()">
        <div class="message-box success" *ngIf="successMessage()" role="status" aria-live="polite">
          {{ successMessage() }}
        </div>

        <div class="message-box error" *ngIf="errorState() as error" role="alert" aria-live="assertive">
          <p>{{ error.title }}</p>
          <ul>
            <li *ngFor="let message of error.messages">{{ message }}</li>
          </ul>

          <div class="error-meta" *ngIf="error.problemCode || error.issueCodes.length > 0 || error.correlationId">
            <span *ngIf="error.problemCode">Problem code: {{ error.problemCode }}</span>
            <span *ngIf="error.issueCodes.length > 0">Issue codes: {{ error.issueCodes.join(', ') }}</span>
            <span *ngIf="error.correlationId">Correlation ID: {{ error.correlationId }}</span>
          </div>
        </div>

        <p class="loading-text" *ngIf="!programScopeKeysLoaded()" role="status" aria-live="polite">
          Loading program scopes...
        </p>

        <p class="empty-state" *ngIf="programScopeKeysLoaded() && !hasProgramScopeKeyOptions()" role="status">
          No program scopes are configured for intake. Submit is disabled until at least one option is available.
        </p>

        <ez-form
          *ngIf="programScopeKeysLoaded() && hasProgramScopeKeyOptions()"
          #intakeForm
          [config]="formConfig()"
          [(formValues)]="formValues"
          [disabled]="isSubmitting()"
          [showFormErrors]="true"
        ></ez-form>

        <div class="form-actions">
          <ez-button
            [buttonText]="isSubmitting() ? 'Submitting...' : submitButtonText"
            [disabled]="isSubmitting() || !hasProgramScopeKeyOptions()"
            (click)="submit()"
          ></ez-button>
          <ez-button
            severity="secondary"
            [buttonText]="'Reset'"
            [disabled]="isSubmitting()"
            (click)="resetForm()"
          ></ez-button>
        </div>
      </ng-container>
    </div>
  </ez-block>
</ez-section>

